import Column from '@/classes/templates/Column'

export default class Columns extends Array {
  constructor (columns, ...rest) {
    Array.isArray(columns) ? super(...columns.map(column => new Column(column))) : super(...rest)
  }

  get (name) {
    return this.find(column => column.name === name)
  }
}
